import React from "react";
import SvgIcon, {SvgIconProps} from "@material-ui/core/SvgIcon";

// Small corner badges overlaid on the base card/building icon, shared across
// both payment methods. Positions/sizes match the Figma legend exactly
// (8x8 badge, bottom-right corner of a 16x16 base icon).
const CheckBadge = ({x, y}: {x: number; y: number}) => (
  <g transform={`translate(${x} ${y})`}>
    <circle cx="4" cy="4" r="4" fill="white" />
    <path
      d="M4 0C1.792 0 0 1.792 0 4C0 6.208 1.792 8 4 8C6.208 8 8 6.208 8 4C8 1.792 6.208 0 4 0ZM3.2 6L1.2 4L1.764 3.436L3.2 4.868L6.236 1.832L6.8 2.4L3.2 6Z"
      fill="#4CAF50"
    />
  </g>
);

const RefundBadge = ({
  x,
  y,
  color = "#FF9800",
}: {
  x: number;
  y: number;
  color?: string;
}) => (
  <g transform={`translate(${x} ${y})`}>
    <path
      d="M8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4Z"
      fill="white"
    />
    <path
      d="M4.14 3.4C3.9 3.4 3.67667 3.45493 3.47 3.5648C3.26333 3.67493 3.09333 3.82 2.96 4H3.2C3.31333 4 3.40827 4.03827 3.4848 4.1148C3.5616 4.1916 3.6 4.28667 3.6 4.4C3.6 4.51333 3.5616 4.60827 3.4848 4.6848C3.40827 4.7616 3.31333 4.8 3.2 4.8H2C1.88667 4.8 1.79173 4.7616 1.7152 4.6848C1.6384 4.60827 1.6 4.51333 1.6 4.4V3.2C1.6 3.08667 1.6384 2.9916 1.7152 2.9148C1.79173 2.83827 1.88667 2.8 2 2.8C2.11333 2.8 2.20827 2.83827 2.2848 2.9148C2.3616 2.9916 2.4 3.08667 2.4 3.2V3.42C2.61333 3.16667 2.86827 2.96667 3.1648 2.82C3.4616 2.67333 3.78667 2.6 4.14 2.6C4.69333 2.6 5.17173 2.76507 5.5752 3.0952C5.9784 3.42507 6.23667 3.84 6.35 4.34C6.37667 4.46 6.35333 4.5667 6.28 4.66C6.20667 4.7533 6.11333 4.8 6 4.8C5.9 4.8 5.80827 4.77 5.7248 4.71C5.6416 4.65 5.5867 4.5733 5.56 4.48C5.4867 4.1667 5.3183 3.9083 5.0548 3.7048C4.7916 3.5016 4.4867 3.4 4.14 3.4ZM4 8C4.55333 8 5.07333 7.89493 5.56 7.6848C6.04667 7.47493 6.47 7.19 6.83 6.83C7.19 6.47 7.47493 6.04667 7.6848 5.56C7.89493 5.07333 8 4.55333 8 4C8 3.44667 7.89493 2.92667 7.6848 2.44C7.47493 1.95333 7.19 1.53 6.83 1.17C6.47 0.81 6.04667 0.524933 5.56 0.3148C5.07333 0.104933 4.55333 0 4 0C3.44667 0 2.92667 0.104933 2.44 0.3148C1.95333 0.524933 1.53 0.81 1.17 1.17C0.81 1.53 0.525067 1.95333 0.3152 2.44C0.105067 2.92667 0 3.44667 0 4C0 4.55333 0.105067 5.07333 0.3152 5.56C0.525067 6.04667 0.81 6.47 1.17 6.83C1.53 7.19 1.95333 7.47493 2.44 7.6848C2.92667 7.89493 3.44667 8 4 8Z"
      fill={color}
    />
  </g>
);

const CancelBadge = ({x, y}: {x: number; y: number}) => (
  <g transform={`translate(${x} ${y})`}>
    <path
      d="M6.85714 4C6.85714 5.57796 5.57796 6.85714 4 6.85714C2.42204 6.85714 1.14286 5.57796 1.14286 4C1.14286 2.42204 2.42204 1.14286 4 1.14286C5.57796 1.14286 6.85714 2.42204 6.85714 4Z"
      fill="white"
    />
    <path
      d="M2.28 5.72C2.35333 5.79333 2.44667 5.83 2.56 5.83C2.67333 5.83 2.76667 5.79333 2.84 5.72L4 4.56L5.17 5.73C5.24333 5.80333 5.33507 5.83827 5.4452 5.8348C5.55507 5.8316 5.64667 5.79333 5.72 5.72C5.79333 5.64667 5.83 5.55333 5.83 5.44C5.83 5.32667 5.79333 5.23333 5.72 5.16L4.56 4L5.73 2.83C5.80333 2.75667 5.83827 2.66493 5.8348 2.5548C5.8316 2.44493 5.79333 2.35333 5.72 2.28C5.64667 2.20667 5.55333 2.17 5.44 2.17C5.32667 2.17 5.23333 2.20667 5.16 2.28L4 3.44L2.83 2.27C2.75667 2.19667 2.66507 2.1616 2.5552 2.1648C2.44507 2.16827 2.35333 2.20667 2.28 2.28C2.20667 2.35333 2.17 2.44667 2.17 2.56C2.17 2.67333 2.20667 2.76667 2.28 2.84L3.44 4L2.27 5.17C2.19667 5.24333 2.16173 5.33493 2.1652 5.4448C2.1684 5.55493 2.20667 5.64667 2.28 5.72ZM4 8C3.44667 8 2.92667 7.89493 2.44 7.6848C1.95333 7.47493 1.53 7.19 1.17 6.83C0.81 6.47 0.525067 6.04667 0.3152 5.56C0.105067 5.07333 0 4.55333 0 4C0 3.44667 0.105067 2.92667 0.3152 2.44C0.525067 1.95333 0.81 1.53 1.17 1.17C1.53 0.81 1.95333 0.524933 2.44 0.3148C2.92667 0.104933 3.44667 0 4 0C4.55333 0 5.07333 0.104933 5.56 0.3148C6.04667 0.524933 6.47 0.81 6.83 1.17C7.19 1.53 7.47493 1.95333 7.6848 2.44C7.89493 2.92667 8 3.44667 8 4C8 4.55333 7.89493 5.07333 7.6848 5.56C7.47493 6.04667 7.19 6.47 6.83 6.83C6.47 7.19 6.04667 7.47493 5.56 7.6848C5.07333 7.89493 4.55333 8 4 8Z"
      fill="#F44336"
    />
  </g>
);

const ClockBadge = ({x, y, color}: {x: number; y: number; color: string}) => (
  <g transform={`translate(${x} ${y})`}>
    <path
      d="M8 4C8 6.20914 6.20914 8 4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4Z"
      fill="white"
    />
    <path
      d="M4 0C1.8 0 0 1.8 0 4C0 6.2 1.8 8 4 8C6.2 8 8 6.2 8 4C8 1.8 6.2 0 4 0ZM5.68 5.68L3.6 4.4V2H4.2V4.08L6 5.16L5.68 5.68Z"
      fill={color}
    />
  </g>
);

// The 15x12 card body, offset at (0.5,2), recolored per status. Card-family
// viewBoxes are squares centered on this shape's own center (8,8), sized
// per variant to also fit the badge without clipping.
export const CardBody = ({color}: {color: string}) => (
  <path
    d="M14 2H2C1.1675 2 0.5075 2.6675 0.5075 3.5L0.5 12.5C0.5 13.3325 1.1675 14 2 14H14C14.8325 14 15.5 13.3325 15.5 12.5V3.5C15.5 2.6675 14.8325 2 14 2ZM14 12.5H2V8H14V12.5ZM14 5H2V3.5H14V5Z"
    fill={color}
  />
);

export const PreAuthorisedCardIcon = createPaymentStatusIcon(
  <>
    <CardBody color="#757575" />
    <ClockBadge x={10} y={9} color="#757575" />
  </>,
  "0 0 18 17"
);

export const PaidCardIcon = createPaymentStatusIcon(
  <>
    <CardBody color="#4CAF50" />
    <CheckBadge x={10} y={9} />
  </>,
  "-2 -2 20 20"
);

export const PartiallyRefundedCardIcon = createPaymentStatusIcon(
  <>
    <CardBody color="#4CAF50" />
    <RefundBadge x={10} y={9} />
  </>,
  "-2 -2 20 20"
);

export const CancelledCardIcon = createPaymentStatusIcon(
  <>
    <CardBody color="#F44336" />
    <CancelBadge x={10} y={9} />
  </>,
  "-2 -2 20 20"
);

export const CancelledAndRefundedCardIcon = createPaymentStatusIcon(
  <>
    <CardBody color="#F44336" />
    <RefundBadge x={10} y={9} color="#F44336" />
  </>,
  "-2 -2 20 20"
);

// The 14x14.7 building/bars shape, centered in a 16x16 icon (offset 1,1), recolored per status.
const BankTransferBody = ({color}: {color: string}) => (
  <g transform="translate(1 1)">
    <path d="M3.5 6.2999H1.4V11.2004H3.5V6.2999Z" fill={color} />
    <path d="M8.05 6.2999H5.95V11.2004H8.05V6.2999Z" fill={color} />
    <path d="M14 12.5998H0V14.7H14V12.5998Z" fill={color} />
    <path d="M12.6 6.2999H10.5V11.2004H12.6V6.2999Z" fill={color} />
    <path d="M7 0L0 3.50033V4.90047H14V3.50033L7 0Z" fill={color} />
  </g>
);

export const DueBankTransferIcon = createPaymentStatusIcon(
  <>
    <BankTransferBody color="#757575" />
    <ClockBadge x={10} y={10} color="#757575" />
  </>,
  "0 0 18 18"
);

export const OverdueBankTransferIcon = createPaymentStatusIcon(
  <>
    <BankTransferBody color="#FF9800" />
    <ClockBadge x={10} y={10} color="#FF9800" />
  </>,
  "0 0 18 18"
);

export const PaidBankTransferIcon = createPaymentStatusIcon(
  <>
    <BankTransferBody color="#4CAF50" />
    <CheckBadge x={10} y={10} />
  </>,
  "0 0 18 18"
);

export const PartiallyRefundedBankTransferIcon = createPaymentStatusIcon(
  <>
    <BankTransferBody color="#4CAF50" />
    <RefundBadge x={10} y={10} />
  </>,
  "0 0 18 18"
);

export const CancelledBankTransferIcon = createPaymentStatusIcon(
  <>
    <BankTransferBody color="#F44336" />
    <CancelBadge x={10} y={10} />
  </>,
  "0 0 18 18"
);

export const CancelledAndRefundedBankTransferIcon = createPaymentStatusIcon(
  <>
    <BankTransferBody color="#F44336" />
    <RefundBadge x={10} y={10} color="#F44336" />
  </>,
  "0 0 18 18"
);

function createPaymentStatusIcon(content: React.ReactElement, viewBox: string) {
  const Icon: React.FC<Pick<SvgIconProps, "fontSize">> = (props) => (
    <SvgIcon {...props} viewBox={viewBox}>
      {content}
    </SvgIcon>
  );
  return Icon;
}
